import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, small, children, onClick }: ButtonProps) => (
  <StyledButton color={color} small={small} onClick={onClick}>
    {children}
  </StyledButton>
);
